export default __webpack_public_path__ + "static/media/hewlett.fad6d0ed.svg";